import axiosApiInstance from 'src/api/axiosConfig';
import { NotificationResponse } from 'src/components/common/ShsAlert/constants';

export const useNotification = () => {
    const READ_NOTIFICATION = 'readNotifications';
    const NOTIFICATION_LENGTH = 'notificationLength';
    const NOTIFICATIONS = 'notifications';

    const getNotification = () => {
        axiosApiInstance.get(`notifications`).then((response) => {
            localStorage.setItem(NOTIFICATIONS, JSON.stringify(response.data));
            saveNotificationLengthToLocalStorage(String(response.data.length || 0));
            updateNotificationLocalState(response.data);
        });
        return JSON.parse(localStorage.getItem(NOTIFICATIONS) || 'null');
    };

    const refetchNotifications = (): Promise<NotificationResponse[]> => {
        return axiosApiInstance.get<NotificationResponse[]>(`notifications`).then((response) => {
            const newData = response.data || [];
            localStorage.setItem(NOTIFICATIONS, JSON.stringify(newData));
            saveNotificationLengthToLocalStorage(String(newData.length));
            updateNotificationLocalState(newData);
            return newData;
        });
    };

    const saveNotificationLengthToLocalStorage = (notificationLength: string) => {
        localStorage.setItem(NOTIFICATION_LENGTH, notificationLength);
    };
    const updateNotificationLocalState = (notifications: NotificationResponse[]) => {
        const readNotifications = getLocalNotification();
        const mappedNotifications = notifications.map((x: NotificationResponse) => x.userId);
        readNotifications.forEach((x: NotificationResponse['userId']) => {
            if (!mappedNotifications.includes(x)) {
                changeNotificationReadStatus(x);
            }
        });
    };

    const getNotificationLengthFromLocalStorage = () => {
        const allNotifications = localStorage.getItem(NOTIFICATION_LENGTH) || 0;
        const notificationIds = localStorage.getItem(READ_NOTIFICATION);
        const readNotifications = notificationIds ? JSON.parse(notificationIds) : [];
        return +allNotifications - readNotifications.length;
    };

    const changeNotificationReadStatus = (id?: number) => {
        const readNotifications = localStorage.getItem(READ_NOTIFICATION);
        const data = readNotifications ? JSON.parse(readNotifications) : [];

        if (!data.find((x: number) => x === id)) {
            localStorage.setItem(READ_NOTIFICATION, JSON.stringify([...data, id]));
        } else {
            localStorage.setItem(READ_NOTIFICATION, JSON.stringify([...data.filter((x: number) => x !== id)]));
        }
    };

    const getLocalNotification = () => {
        const readNotifications = localStorage.getItem(READ_NOTIFICATION);

        return readNotifications ? JSON.parse(readNotifications) : [];
    };

    const clearLocalStorage = () => {
        localStorage.removeItem(READ_NOTIFICATION);
        localStorage.removeItem(NOTIFICATION_LENGTH);
        localStorage.removeItem(NOTIFICATIONS);
    };

    return {
        getNotification,
        refetchNotifications,
        getNotificationLengthFromLocalStorage,
        changeNotificationReadStatus,
        getLocalNotification,
        clearLocalStorage
    };
};

export const NOTIFICATIONS_REFRESHED_EVENT = 'notifications-refreshed';
